import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./css/style.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { ApiProvider } from "./Api/ApiContext";
import * as api from "./Api";
import { BrowserRouter } from "react-router-dom";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";

Bugsnag.start({
  apiKey: "6f293229b79008c9c5e2468ac141b7e0",
  plugins: [new BugsnagPluginReact()],
  releaseStage: "staging",
  appVersion: "0.0",
});

BugsnagPerformance.start({ apiKey: "6f293229b79008c9c5e2468ac141b7e0" });
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <ApiProvider value={api}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApiProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
